import styled from '@emotion/styled';
import { Theme } from 'ui_system/theme';

export { Theme };

export const CheckList = styled('div')`
  border-top: solid 1px ${Theme.colors.inputs.border};
  margin-bottom: 15px;
  width: 100%;
  div.checkboxItem:last-child {
    margin-top: 15px;
    border-top: solid 1px ${Theme.colors.inputs.border};
  }
`;

export const CheckboxItem = styled('div')`
  padding: 10px;
  border: solid 1px ${Theme.colors.inputs.border};
  border-top: none;
  cursor: pointer;
`;

export const Checkbox = styled('div')`
  border-radius: ${(props) => (props.circle ? '30px' : '0px')};
  height: 24px;
  width: 24px;
  background: ${(props) =>
    props.active ? props.color : Theme.colors.lightBackground};
  display: inline-block;
  margin-right: 20px;

  vertical-align: top;
  border: solid 1px ${Theme.colors.inputs.border};
  cursor: pointer;
  text-align: center;
  line-height: 24px;
  @media (max-width: 700px) {
    height: 22px;
    width: 22px;
    margin-right: 10px;
  }
  &:af-checkmark {
    color: ${Theme.colors.inputs.border};
  }
`;

export const Checkmark = styled('span')`
  .af-checkmark {
    width: 24px;
    height: 24px;
    line-height: 16px;
    font-size: 12px;
    position: relative;
    top: -2px;
    left: -1px;
    margin: 7px 0px 7px 0;
    text-align: center;
    &.af-checkmark {
      background: transparent;
      color: #fff;
      border: 0;
    }
    @media (max-width: 700px) {
      top: -3px;
      left: -2px;
    }
  }
`;

export const CheckboxContent = styled('div')`
  width: 90%;
  display: inline-block;
  font-size: 14px;
  line-height: 19px;
  position: relative;
  top: 1px;
  @media (max-width: 700px) {
    width: 80%;
    font-size: 12px;
  }
  p {
    color: #999;
  }
`;

export const TextInput = styled('textarea')`
  height: 80px;
  width: 100%;
  padding-top: 14px;
  padding-bottom: 14px;
  padding-left: 10px;
  padding-right: 10px;
  resize: none;

  box-sizing: border-box;
  border: 1px solid ${Theme.colors.inputs.border};
  border-radius: 0px;
  font-size: 14px;
  background: white;
`;

export const Label = styled('div')`
  font-size: 18px;
  font-weight: 600;
`;

export const SubLabel = styled(Label)`
  margin-bottom: 0px;
  font-size: 16px;
  color: ${Theme.colors.lightText};
  font-weight: normal;
`;

export const LabelBox = styled('div')`
  margin-bottom: 30px;
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    margin-bottom: 10px;
  }
`;

export const Section = styled('div')`
  padding: 0px 50px 50px 50px;
  max-width: 768px;
  margin: 0 auto;

  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    padding-left: 20px;
    padding-right: 20px;
    padding: 0px 30px 30px 30px;
  }
`;
